import SseHub from './SseHub.js';

const subscribers = [];
const CANAL = 'alertas';
let enganchado = false;

function notifySubscribers(payload) {
    subscribers.slice().forEach(function (callback) {
        try {
            callback(payload);
        } catch (err) {
            console.error('AlertasEvents subscriber threw', err);
        }
    });
}

function ensureConnected() {
    if (enganchado) return;
    enganchado = true;
    // Sin conexion propia: el hub trae todos los canales por un unico stream compartido entre
    // pestanas. El servidor entrega este canal SOLO a las conexiones del usuario destinatario.
    SseHub.subscribe(CANAL, notifySubscribers);
}

function disconnect() {
    if (enganchado) {
        SseHub.unsubscribe(CANAL, notifySubscribers);
        enganchado = false;
    }
}

export default {
    subscribe(callback) {
        if (typeof callback !== 'function') {
            return;
        }
        subscribers.push(callback);
        ensureConnected();
    },
    unsubscribe(callback) {
        const index = subscribers.indexOf(callback);
        if (index >= 0) {
            subscribers.splice(index, 1);
        }
        if (subscribers.length === 0) {
            disconnect();
        }
    }
};
